/* eslint-disable */
import { useEffect } from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../components/features/Datatable";
import Filter from "./filter";
import { fetchOutboundListing, selectOutboundList } from "../../../slices/logisticSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { hasAuthority } from "../../../../utils/authorities";
import ChatModule from "../../Chat";
import { addPatientList, addPhaseList } from "../../../slices/chat";
import {capitalizeWords} from "../../../../utils/utils"
const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
};

const OutBound = () => {
  const navigate = useNavigate();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const dispatch = useDispatch();
  const outboundList = useSelector(selectOutboundList);
  const updateFilter = (filter) => {
    fetchUsers(filter);
  };

  const fetchUsers = async (filter) => {
    await dispatch(fetchOutboundListing(filter));
  };

  const columns = [
    {
      id: "patient_id",
      name: "ID",
      selector: (row) =>
        row.patient_id ? row.patient_id : "N/A",
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product_phase",
      name: "Product/Phase",
      selector: (row) =>
        row.product && row.phase
          ? `${capitalizeWords(row.product)}/${capitalizeWords(row.phase)}`
          : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "status",
      name: "Status",
      selector: (row) =>
        row.status ? (
          <p className={`${ row.status === "Shipped"
              ? "text-[#00B278]"
              : row.status === "Pending"
              ? "text-[#FF2023]"
              : "text-[#24B9DF]" 
          } font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]`}
        > {row?.status}
            </p>
        ) : (
          "N/A"
        ),
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <Button
          onClick={() =>
            navigate(`/bmr/logistics-management/out-bound/view/${row?.qr_code_generated_id}/${row?.id}`,{
               state: [
            { name: "LSM Outbond", path: location.pathname },
            {
              name: "Details",
              path: `/bmr/logistics-management/out-bound/view/${row?.qr_code_generated_id}/${row?.id}`,
            },
            ]
            })
          }
          key={row?.subject_id}
          size="small"
          className="!w-[100px]"
        >
          View Details
        </Button>
      ),
    },
  ];



  useEffect(() => {
      const phaseList = outboundList?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase} (${op?.product})`, patient_id: op?.subject_id } })
      const patientList = outboundList?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
      dispatch(addPatientList(patientList))
      dispatch(addPhaseList(phaseList))
  }, [outboundList])


  return (
    <Grid
      container
      className="mt-4 ml-0 mr-3 mainDiv"
      rowSpacing={4.5}
      columnSpacing={2.75}
    >
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        {hasAuthority(['in-bound-listing'], bmr_permissions) &&
          <div>
            <DataTable
              columns={columns}
              data={outboundList}
              title="LSM Outbond"
              FilterComponent={Filter}
              onServerSideChange={updateFilter}
              remote={true}
              filterConfig={filterConfig}
            />
            <ChatModule />
          </div>
        }
      </Grid>
    </Grid>
  );
};

export default OutBound;
